import React from 'react';
import { Form, Radio } from 'ssc-ui-react';

import { $gt } from '@/common/appCtx';

import { CacheType, TimeRange } from '../../const';
import { dashboardDBManager } from '../../utils/storage';
import styles from './index.module.less';
import OperatorPerformanceLastHour from './operator-performance/last-hour';
import OperatorPerformanceLastTenHours from './operator-performance/last-ten-hours';
import WorkstationPerformanceLastHour from './workstation-permance/last-hour';
import WorkstationPerformanceLastTenHours from './workstation-permance/last-ten-hours';

const WorkstationOperatorPerformance: React.FC = () => {
  const [timeRange, setTimeRange] = React.useState(TimeRange.Last1Hour);

  const getCache = React.useCallback(async () => {
    try {
      const cache = await dashboardDBManager.get(CacheType.TimeRange);
      const timeRange = cache as TimeRange || TimeRange.Last1Hour;
      setTimeRange(timeRange);
    } catch (error) {
      console.error('[WorkstationOperatorPerformance] getCache error: ', error);
    }
  }, []);

  const setCache = React.useCallback((value: TimeRange) => {
    dashboardDBManager.put(CacheType.TimeRange, value);
  }, []);

  React.useLayoutEffect(() => {
    getCache();
  }, [getCache]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.head}>
        <Form.Legend
          level={2}
          tooltip={$gt('Use the “Last 1 Hour” and “Last 10 Hours” buttons on the right side to switch between the tabs.')}
        >
          {$gt('Workstation & Operator Performance')}
        </Form.Legend>
        <Radio.Group
          value={timeRange}
          onChange={e => {
            const timeRange = e.target.value as TimeRange;
            setTimeRange(timeRange);
            setCache(timeRange);
          }}
        >
          <Radio.Button value={TimeRange.Last1Hour}>
            {$gt('Last 1 Hour')}
          </Radio.Button>
          <Radio.Button value={TimeRange.Last10Hours}>
            {$gt('Last 10 Hours')}
          </Radio.Button>
        </Radio.Group>
      </div>
      <div className={styles.divider}></div>
      {timeRange === TimeRange.Last1Hour ? (
        <>
          <WorkstationPerformanceLastHour />
          <OperatorPerformanceLastHour />
        </>
      ) : (
        <>
          <WorkstationPerformanceLastTenHours />
          <OperatorPerformanceLastTenHours />
        </>
      )}
    </div>
  );
};

export default WorkstationOperatorPerformance;
